/**
 * Test IDs for QA automation.
 */
export const testIds = {
  transactionFormShipment: "transaction-form-shipment",
  transactionFormShipmentOption: "transaction-form-shipment-option",
  transactionFormLabelPicker: "transaction-form-label-picker",
  transactionFormLabelSearch: "transaction-form-label-search",
  transactionFormQuantity: "transaction-form-quantity",
  transactionFormUnitPicker: "transaction-form-unit-picker",
  transactionFormUnitSearch: "transaction-form-unit-search",
  transactionFormRate: "transaction-form-rate",
  transactionFormTotal: "transaction-form-total",
  transactionFormAddToSettlement: "transaction-form-add-to-settlement",
  transactionFormTaxable: "transaction-form-taxable",
  transactionFormFinanceAddDocument: "transaction-form-finance-add-document",
} as const;
